import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { WorkflowTemplateHeader } from "./WorkflowTemplateHeader";
import { CreateWorkflowTemplateModal } from "./CreateWorkflowTemplateModal";
import { toast } from "react-toastify";
import workflowApi from "../../api/workflowApi";
import { TemplatesTab } from "../Workflow/TemplatesTab";
import { PerformanceMetrics } from "../Workflow/PerformanceMetrics";
import Loading from "../../components/Loading";
import { CreateWorkflowTemplateModalCreate } from "./CreateWorkflowTemplateModalCreate";

export const WorkflowTemplateManagement = () => {
    const token = useSelector((state) => state.auth.access_token);

    const [activeTab, setActiveTab] = useState("templates");
    const [workflowTemplates, setWorkflowTemplates] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [showCreateTemplate, setShowCreateTemplate] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchTemplates = async () => {
        try {
            setLoading(true);
            const response = await workflowApi.getAllWorkflowTemplates(token);
            setWorkflowTemplates(response?.data || []);
        } catch (error) {
            console.error("Error fetching workflow templates:", error);
            // toast.error("Failed to load workflow templates.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [token]);

    const filteredTemplates = selectedCategory
        ? workflowTemplates.filter((tpl) => tpl.category === selectedCategory)
        : workflowTemplates;

    const formatText = (text = "") =>
    text
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    return (
        <div className="space-y-2">
            <WorkflowTemplateHeader
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                workflowTemplates={workflowTemplates}
                setShowCreateTemplate={setShowCreateTemplate}
            />
            
            {loading ? (
                <Loading />
            ) : (
                <>
                    {activeTab === "templates" && (
                        <TemplatesTab
                            workflowTemplates={workflowTemplates}
                            showActions={true}
                            refreshTemplates={fetchTemplates}
                            token={token}
                        />
                    )}

                    {activeTab === "categories" && (
                        <div className="bg-white p-2 rounded-lg shadow border border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-1">
                                Templates by Category
                            </h3>
                            {filteredTemplates.length === 0 ? (
                                <p className="text-sm text-gray-500">
                                    No templates found for this category.
                                </p>
                            ) : (
                                <div className="space-y-2">
                                    {filteredTemplates.map((tpl) => (
                                        <div
                                            key={tpl.id}
                                            className="border p-3 rounded-lg flex justify-between items-center"
                                        >
                                            <span className="font-medium">{formatText(tpl.name)}</span>
                                            <span className="text-sm text-gray-500">{formatText(tpl.category)}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === "assigned" && (
                        <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Instantiated Workflows from Templates
                            </h3>
                            <p className="text-sm text-gray-500">
                                Coming soon: List of workflows created from these templates.
                            </p>
                        </div>
                    )}
                </>
            )}

            {/* Create Workflow Template Modal */}
            {showCreateTemplate && (
                <CreateWorkflowTemplateModalCreate
                    setShowCreateTemplate={setShowCreateTemplate}
                    onTemplateCreated={fetchTemplates}
                />
            )}
        </div>
    );
};
